export default __webpack_public_path__ + "static/media/check.a8dcefb7.svg";